import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import "./App.css";
import "./styles/comingsoon.css";
import LandingPage from "./pages/LandingPage";
import AgentsPage from "./pages/AgentsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import CustomCursor from "./components/ui/CustomCursor";
import ScrollToTop from "./components/ui/ScrollToTop";

function App() {
  return (
    <Router>
      <div className="App">
        <CustomCursor />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          <Route path="/pricing" element={<Navigate to="/coming-soon" replace />} />
          <Route path="/login" element={<Navigate to="/coming-soon" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
